(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["on-accessory-variant-media"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('on-accessory-media')) {
 customElements.define('on-accessory-media', class extends HTMLElement {
  connectedCallback() {
   this.sources = JSON.parse(this.dataset.sources);
   this.form = document.forms[this.getAttribute('form')];
   this.update = event => {
    const id = event?.detail?.variant?.id || this.form?.elements.id?.value || this.dataset.initial;
    const source = this.sources[id];
    this.replaceChildren();
    this.hidden = !source?.src;
    if (source?.src) {
     const img = document.createElement('img');
     img.src = source.src;
     img.alt = source.alt;
     img.width = 80;
     img.height = 80;
     img.style.objectFit = 'contain';
     img.className = 'rounded-xs';
     this.append(img);
    }
   };
   this.form?.addEventListener('variant:change', this.update);
   this.update();
  }
  disconnectedCallback() { this.form?.removeEventListener('variant:change', this.update); }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["outdoor-ninja-camp-scene"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('outdoor-ninja-story')) {
  customElements.define('outdoor-ninja-story', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.animations = [];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotion = () => { if(this.motion.matches) this.finish(); };
      this.motion.addEventListener('change',this.onMotion);
      this.controls = this.querySelector('.on-story-controls');
      this.pauseButton = this.querySelector('[data-story-pause]');
      this.skipButton = this.querySelector('[data-story-skip]');
      this.onPause = () => {
        this.paused = !this.paused;
        if(this.paused) {
          this.pausedAt=this.clock.currentTime || 0;
          this.animations.forEach(a=>{a.pause();a.currentTime=Math.min(this.pausedAt,a.effect.getComputedTiming().endTime);});
        } else {
          const start=document.timeline.currentTime-this.pausedAt;
          this.animations.forEach(a=>{
            if(this.pausedAt>=a.effect.getComputedTiming().endTime) a.finish();
            else {a.play();a.startTime=start;}
          });
        }
        this.pauseButton.textContent = this.paused ? this.dataset.play:this.dataset.pause;
      };
      this.onSkip = () => this.finish();
      this.pauseButton.addEventListener('click',this.onPause);
      this.skipButton.addEventListener('click',this.onSkip);
      this.onResize = () => { if(this.hasAttribute('data-running')) this.finish(); };
      window.addEventListener('resize',this.onResize,{passive:true});
      if(this.motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      this.setAttribute('data-ready','');
      this.observer = new IntersectionObserver(entries=>{
        if(entries.some(e=>e.isIntersecting)) {this.observer.disconnect();this.play();}
      },{threshold:.65});
      this.observer.observe(this);
    }
    animateNode(node,frames,duration,delay=0,iterations=1,easing='linear') {
      if(!node) return;
      const a=node.animate(frames,{duration,delay,iterations,easing,fill:'both'});
      this.animations.push(a);
      return a;
    }
    animatePart(selector,frames,duration,delay=0,iterations=1,easing='linear') {
      this.querySelectorAll(selector).forEach(n=>this.animateNode(n,frames,duration,delay,iterations,easing));
    }
    place(selector,x,y) {this.querySelector(selector).setAttribute('transform',`translate(${x} ${y})`);}
    forest(selector,rect,count,treeId,base) {
      const root=this.querySelector(selector);root.replaceChildren();
      for(let i=0;i<count;i++) {
        const height=(rect.height+25)*(1+(i%3-1)*.07);
        const holder=document.createElementNS('http://www.w3.org/2000/svg','g');
        const x=rect.x+(i+.5)*rect.width/count;
        holder.setAttribute('transform',`translate(${x} ${base-height})`);
        const tree=document.createElementNS('http://www.w3.org/2000/svg','use');
        tree.setAttribute('href',`#${treeId}`);
        tree.setAttribute('transform',`scale(${Math.max(.48,rect.width/count/47)} ${height/89})`);
        tree.style.transformOrigin=`0px 89px`;
        holder.append(tree);root.append(holder);
      }
      return root;
    }
    jointFrames(poses,shoulder,lengthA,lengthB,bend) {
      const upper=[],lower=[];
      let lastUpper,lastLower;
      const unwrap=(value,last)=>last===undefined?value:last+((value-last+540)%360)-180;
      for(const pose of poses) {
        const dx=pose.x-shoulder[0],dy=pose.y-shoulder[1];
        const distance=Math.hypot(dx,dy);
        const d=Math.max(.001,Math.min(lengthA+lengthB-.001,distance));
        const a=(lengthA*lengthA-lengthB*lengthB+d*d)/(2*d);
        const h=Math.sqrt(Math.max(0,lengthA*lengthA-a*a));
        const ex=shoulder[0]+a*dx/d-bend*h*dy/d;
        const ey=shoulder[1]+a*dy/d+bend*h*dx/d;
        const ua=unwrap(Math.atan2(ex-shoulder[0],ey-shoulder[1])*-180/Math.PI,lastUpper);
        const la=unwrap(Math.atan2(pose.x-ex,pose.y-ey)*-180/Math.PI,lastLower);
        lastUpper=ua;lastLower=la;
        upper.push({offset:pose.offset,transform:`translate(${shoulder[0]}px,${shoulder[1]}px) rotate(${ua}deg)`});
        lower.push({offset:pose.offset,transform:`translate(${ex}px,${ey}px) rotate(${la}deg)`});
      }
      return {upper,lower};
    }
    chop() {
      const poses=[],rear=[],tool=[],handA=[],handB=[],torso=[];
      const keys=[
        [0,23,-52,65,5],
        [.12,21,-60,47,3],
        [.40,22,-97,-24,-4],
        [.53,22,-97,-24,-4],
        [.74,23,-52,65,5],
        [.80,22,-55,58,4],
        [.92,23,-52,65,5],
        [1,23,-52,65,5]
      ];
      for(let i=0;i<=100;i++) {
        const t=i/100;
        let k=1;while(k<keys.length-1 && t>keys[k][0]) k++;
        const a=keys[k-1],b=keys[k],p=(t-a[0])/(b[0]-a[0]);
        const q=k===4?p*p:p*p*(3-2*p);
        const v=a.map((x,j)=>j?x+(b[j]-x)*q:t);
        const [,x,y,angle,lean]=v,rad=angle*Math.PI/180;
        const rx=x-9*Math.sin(rad),ry=y+9*Math.cos(rad);
        poses.push({offset:t,x,y});rear.push({offset:t,x:rx,y:ry});
        tool.push({offset:t,transform:`translate(${x}px,${y}px) rotate(${angle}deg)`});
        handA.push({offset:t,transform:`translate(${x}px,${y}px)`});
        handB.push({offset:t,transform:`translate(${rx}px,${ry}px)`});
        torso.push({offset:t,transform:`rotate(${lean}deg)`});
      }
      const back=this.jointFrames(rear,[-10,-74],20,19,1);
      const front=this.jointFrames(poses,[11,-74],20,19,-1);
      for(const [selector,frames] of [
        ['.on-axe-rear-upper',back.upper],['.on-axe-rear-lower',back.lower],
        ['.on-axe-front-upper',front.upper],['.on-axe-front-lower',front.lower],
        ['.on-axe-tool',tool],['.on-axe-grip-a',handA],['.on-axe-grip-b',handB],['.on-axe-torso',torso]
      ]) this.animatePart(selector,frames,1100,9200,4);
    }
    walk(selector,start,duration) {
      const cycles=Math.max(1,Math.round(duration/420));
      const framesA=[{transform:'rotate(0deg)'},{transform:'rotate(-14deg)'},{transform:'rotate(14deg)'},{transform:'rotate(0deg)'}];
      const framesB=[{transform:'rotate(0deg)'},{transform:'rotate(14deg)'},{transform:'rotate(-14deg)'},{transform:'rotate(0deg)'}];
      for(const [part,frames] of [['.on-story-leg-a',framesA],['.on-story-leg-b',framesB]]) {
        this.querySelectorAll(selector+' '+part).forEach(node=>{
          const a=node.animate(frames,{duration:duration/cycles,delay:start,iterations:cycles,easing:'ease-in-out',fill:'none'});
          this.animations.push(a);
        });
      }
    }
    play() {
      if(this.motion.matches || this.played) return;
      this.played=true;
      const box=this.getBoundingClientRect(),w=box.width,h=box.height;
      const local=sel=>{const r=this.querySelector(sel).getBoundingClientRect();return {x:r.left-box.left,y:r.top-box.top,width:r.width,height:r.height,bottom:r.bottom-box.top};};
      const gear=local('.on-story-gear'),dein=local('.on-story-dein'),adventure=local('.on-story-adventure');
      const mobile=w<700,scale=mobile?.76:1;
      const ground=Math.max(dein.bottom,adventure.bottom)+108*scale;
      const treeBase=Math.max(dein.bottom,adventure.bottom)+12;
      const grab=mobile?34:70;
      const pull=gear.x+gear.width+25*scale-grab;
      const hikerEnd=gear.x+gear.width+25*scale;
      const hikerTravel=hikerEnd-grab;
      const restHiker=w*(mobile?.22:.32),restBush=w*(mobile?.5:.46),restSurvivor=w*(mobile?.78:.68);
      const treeStep=dein.width/4;
      const bushX=Math.max(35,dein.x+dein.width/8-56*scale),survivorX=Math.max(36,adventure.x-78*scale);
      this.querySelector('svg').setAttribute('viewBox',`0 0 ${w} ${h}`);
      this.querySelectorAll('.on-story-person').forEach(n=>n.setAttribute('transform',`scale(${scale})`));
      const pullGround=gear.bottom+67*scale-13;
      this.place('.on-story-hiker-anchor',grab,pullGround);
      this.place('.on-story-bush-anchor',bushX,treeBase+35*scale);
      this.place('.on-story-survivor-anchor',survivorX,treeBase+23*scale);
      this.place('.on-story-chips-location',dein.x+dein.width/8,treeBase-15*scale);
      const treeId=this.querySelector('defs [id^="on-tree-"]').id,flameId=this.querySelector('defs [id^="on-flame-"]').id;
      this.forest('.on-story-trees-dein',dein,4,treeId,treeBase);
      this.forest('.on-story-trees-adventure',adventure,mobile?5:7,treeId,treeBase);
      const flames=this.querySelector('.on-story-fire');flames.replaceChildren();
      const flameCount=mobile?4:6;
      for(let i=0;i<flameCount;i++) {
        const g=document.createElementNS('http://www.w3.org/2000/svg','g');
        g.setAttribute('transform',`translate(${adventure.x+(i+.45)*adventure.width/flameCount} ${treeBase+15})`);
        const flame=document.createElementNS('http://www.w3.org/2000/svg','use');flame.setAttribute('href',`#${flameId}`);flame.style.transformOrigin='0px 0px';
        g.append(flame);flames.append(g);
        this.animateNode(flame,[{opacity:0,transform:'scale(.05,.05)'},{opacity:1,transform:'scale(.3,.48)',offset:.16},{opacity:1,transform:'scale(.92,1.3)',offset:.32},{opacity:1,transform:'scale(1.2,1.55)',offset:.48},{opacity:.95,transform:'scale(1.05,1.8)',offset:.6},{opacity:.8,transform:'scale(1.12,1.35)',offset:.74},{opacity:.4,transform:'scale(.7,1)',offset:.88},{opacity:0,transform:'scale(.1,.3)'}],2200,18400+i*80);
        const ember=document.createElementNS('http://www.w3.org/2000/svg','path');
        ember.setAttribute('d','M-7 -28l1 -2M9 -45l1 -2M2 -58l.5 -1');
        ember.setAttribute('stroke','currentColor');ember.setAttribute('stroke-width','1.4');g.append(ember);
        this.animateNode(ember,[{opacity:0,transform:'translate(0,0)'},{opacity:.7,transform:'translate(2px,-5px)',offset:.24},{opacity:.4,transform:'translate(-3px,-15px)',offset:.65},{opacity:0,transform:'translate(6px,-30px)'}],1250,18800+i*100);
      }
      this.setAttribute('data-running','');this.controls.hidden=false;
      const tx=x=>`translateX(${x}px)`;
      const pullFrames=[{transform:tx(-pull),offset:0},{transform:tx(-pull),offset:.12},{transform:tx(-pull*.69),offset:.3},{transform:tx(-pull*.69),offset:.43},{transform:tx(-pull*.32),offset:.62},{transform:tx(-pull*.32),offset:.74},{transform:tx(0),offset:1}];
      this.animatePart('.on-story-gear',pullFrames,5000,2800,1,'linear');
      const movement=[{transform:tx(w+90),offset:0},{transform:tx(0),offset:2.8/25},{transform:tx(0),offset:3.4/25},{transform:tx(hikerTravel*.31),offset:4.3/25},{transform:tx(hikerTravel*.31),offset:4.95/25},{transform:tx(hikerTravel*.68),offset:5.9/25},{transform:tx(hikerTravel*.68),offset:6.5/25},{transform:tx(hikerTravel),offset:7.8/25},{transform:`translate(${restHiker-grab}px,${ground-pullGround+48*scale}px)`,offset:8.8/25},{transform:`translate(${restHiker-grab}px,${ground-pullGround+48*scale}px)`,offset:20.5/25},{transform:`translate(${restHiker-grab}px,${ground-pullGround}px)`,offset:21/25},{transform:`translate(${restHiker-grab}px,${ground-pullGround}px)`,offset:22.6/25},{transform:`translate(${w+90}px,${ground-pullGround}px)`,offset:1}];
      this.animatePart('.on-story-hiker',movement,25000);
      this.animatePart('.on-story-hiker .on-story-body',[{transform:'rotate(0deg)',offset:0},{transform:'rotate(4deg)',offset:.2},{transform:'rotate(6deg)',offset:.5},{transform:'rotate(2deg)',offset:.7},{transform:'rotate(0deg)',offset:1}],1666,2800,3,'ease-in-out');
      const pose = (role,start,end,fade=240) => {
        const frames=[{opacity:0,offset:0},{opacity:1,offset:fade/(end-start)},{opacity:1,offset:1-fade/(end-start)},{opacity:0,offset:1}];
        this.animatePart('.on-ninja-'+role+'-work',frames,end-start,start);
        this.animatePart('.on-ninja-'+role+'-idle',frames.map(f=>({...f,opacity:1-f.opacity})),end-start,start);
      };
      pose('hiker',2800,7800,100);
      pose('bush',9200,13700,100);
      pose('survivor',15200,20600,100);
      this.walk('.on-story-hiker',0,2800);this.walk('.on-story-hiker',7800,1000);this.walk('.on-story-hiker',20500,500);this.walk('.on-story-hiker',22600,2400);
      this.animatePart('.on-story-bush',[{opacity:0,transform:tx(w),offset:0},{opacity:0,transform:tx(w),offset:8/25},{opacity:1,transform:tx(0),offset:9.2/25},{opacity:1,transform:tx(treeStep*0),offset:10.100/25},{opacity:1,transform:tx(treeStep*1),offset:10.390/25},{opacity:1,transform:tx(treeStep*1),offset:11.200/25},{opacity:1,transform:tx(treeStep*2),offset:11.490/25},{opacity:1,transform:tx(treeStep*2),offset:12.300/25},{opacity:1,transform:tx(treeStep*3),offset:12.590/25},{opacity:1,transform:tx(treeStep*3),offset:13.7/25},{opacity:1,transform:`translate(${restBush-bushX}px,${ground-treeBase-35*scale}px)`,offset:14.6/25},{opacity:1,transform:`translate(${restBush-bushX}px,${ground-treeBase-35*scale}px)`,offset:22.6/25},{opacity:0,transform:`translate(${-w}px,${ground-treeBase-35*scale}px)`,offset:1}],25000);
      this.walk('.on-story-bush',8000,1200);this.walk('.on-story-bush',13700,900);this.walk('.on-story-bush',22600,2400);
      this.chop();
      this.animatePart('.on-story-chips-anchor',[{transform:'translateX(0)',offset:0},{transform:tx(treeStep*0),offset:0.209},{transform:tx(treeStep*1),offset:0.250},{transform:tx(treeStep*1),offset:0.459},{transform:tx(treeStep*2),offset:0.500},{transform:tx(treeStep*2),offset:0.709},{transform:tx(treeStep*3),offset:0.750},{transform:tx(treeStep*3),offset:1}],4400,9200);

      this.animatePart('.on-story-chips',[{opacity:0,transform:'translate(0,0)',offset:0},{opacity:0,transform:'translate(0,0)',offset:.74},{opacity:1,transform:'translate(0,-3px)',offset:.78},{opacity:0,transform:'translate(20px,-24px)',offset:1}],1100,9200,4);
      this.querySelectorAll('.on-story-trees-dein > g').forEach((n,i)=>{const tree=n.querySelector('use');this.animateNode(tree,[{rotate:'0deg'},{rotate:'3deg',offset:.22},{rotate:'-2deg',offset:.42},{rotate:'14deg',offset:1}],380,10040+i*1100);this.animateNode(n,[{opacity:1},{opacity:0}],380,10040+i*1100);});
      this.animatePart('.on-story-dein',[{clipPath:'inset(0 100% 0 0)',offset:0},{clipPath:'inset(0 75% 0 0)',offset:.02},{clipPath:'inset(0 75% 0 0)',offset:.31},{clipPath:'inset(0 50% 0 0)',offset:.34},{clipPath:'inset(0 50% 0 0)',offset:.64},{clipPath:'inset(0 25% 0 0)',offset:.67},{clipPath:'inset(0 25% 0 0)',offset:.97},{clipPath:'inset(0 0 0 0)',offset:1}],3300,10040);
      this.animatePart('.on-story-survivor',[{opacity:0,transform:tx(w),offset:0},{opacity:0,transform:tx(w),offset:14/25},{opacity:1,transform:tx(0),offset:15.2/25},{opacity:1,transform:tx(0),offset:20.6/25},{opacity:1,transform:`translate(${restSurvivor-survivorX}px,${ground-treeBase-23*scale}px)`,offset:21/25},{opacity:1,transform:`translate(${restSurvivor-survivorX}px,${ground-treeBase-23*scale}px)`,offset:22.6/25},{opacity:0,transform:`translate(${w}px,${ground-treeBase-23*scale}px)`,offset:1}],25000);
      this.walk('.on-story-survivor',14000,1200);this.walk('.on-story-survivor',20600,400);this.walk('.on-story-survivor',22600,2400);
      this.animatePart('.on-story-scraper',[{transform:'translate(4px,-35px) rotate(-75deg)',offset:0},{transform:'translate(4px,-35px) rotate(-75deg)',offset:.38,easing:'ease-in'},{transform:'translate(4px,-35px) rotate(-56deg)',offset:.72},{transform:'translate(4px,-35px) rotate(-56deg)',offset:.84,easing:'ease-in-out'},{transform:'translate(4px,-35px) rotate(-75deg)',offset:1}],1000,15400,3);
      this.animatePart('.on-story-sparks',[{opacity:0,transform:'scale(.15)',offset:0},{opacity:0,transform:'scale(.15)',offset:.67},{opacity:1,transform:'scale(.55)',offset:.72},{opacity:1,transform:'scale(.9)',offset:.84},{opacity:0,transform:'scale(1.25)',offset:1}],1000,15400,3);
      this.querySelectorAll('.on-story-trees-adventure > g').forEach((n,i)=>this.animateNode(n,[{opacity:1},{opacity:0}],650,19200+i*190));
      this.animatePart('.on-story-adventure',[{clipPath:'inset(0 100% 0 0)'},{clipPath:'inset(0 0 0 0)'}],1700,19200);
      this.animatePart('.on-story-normal-arms',[{opacity:1,offset:0},{opacity:0,offset:.04},{opacity:0,offset:.96},{opacity:1,offset:1}],1600,21000);
      this.animatePart('.on-story-cheer-arms,.on-story-survivor-cheer',[{opacity:0,offset:0},{opacity:1,offset:.04},{opacity:1,offset:.96},{opacity:0,offset:1}],1600,21000);
      this.animatePart('.on-story-jump',[{transform:'translateY(0)'},{transform:'translateY(-12px)'},{transform:'translateY(0)'}],500,21100,3,'ease-in-out');
      this.clock=this.animations.find(a=>a.effect.getTiming().duration===25000);
      const start=document.timeline.currentTime;this.animations.forEach(a=>{a.startTime=start;});
      Promise.all(this.animations.map(a=>a.finished.catch(()=>{}))).then(()=>this.finish());
    }
    finish() {
      this.observer?.disconnect();
      this.animations?.forEach(a=>a.cancel());this.animations=[];this.pausedAnimations=[];
      const finalHeight=this.querySelector('.on-story-title').getBoundingClientRect().height+8;
      this.style.height=finalHeight+'px';
      this.setAttribute('data-finished','');
      this.removeAttribute('data-running');if(this.controls)this.controls.hidden=true;
      this.played=true;
    }
    disconnectedCallback() {
      this.finish();this.motion?.removeEventListener('change',this.onMotion);
      window.removeEventListener('resize',this.onResize);
      this.pauseButton?.removeEventListener('click',this.onPause);this.skipButton?.removeEventListener('click',this.onSkip);
      this.initialized=false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-rating"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a.on-judge-rating');
  if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!link.closest('.product-info') || !widget) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const section = widget.closest('[id$="__judgeme-product-reviews"]');
    if (section) section.classList.add('on-reviews-open');
    link.setAttribute('aria-expanded', 'true');
    widget.setAttribute('tabindex', '-1');
    requestAnimationFrame(() => {
      widget.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
      widget.focus({ preventScroll: true });
    });
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
